import axios from 'axios';
import history from '../lib/history';

// const navigate = useNavigate();

let API_URL = null;

if (window.location.hostname.indexOf('4boxes.com.au') > -1) {
  API_URL = 'https://api.4boxes.com.au/api';
} else {
  // API_URL = 'https://four-boxes.herokuapp.com/api';
  // API_URL = 'http://127.0.0.1:3000/api';
  API_URL = 'http://localhost:3000/api';
}

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Content-Security-Policy': 'upgrade-insecure-requests',
  },
});

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    // 'Content-Security-Policy': 'upgrade-insecure-requests',
  },
});

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase();
  if (method !== 'OPTIONS') {
    config.headers = {
      ...config.headers,
      Authorization: localStorage.getItem('userToken'),
      // Authorization: JSON.parse(
      //   JSON.parse(localStorage.getItem('persist:root')).user
      // ).userToken,
    };
  }
  return config;
});

securedAxiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(error);
    if (error.response.status === 401) {
      // redirect to login
      history.replace('/user/auth');

      console.log('401 ERROR');

      return Promise.reject(error);
    }
    if (error.response.status === 403) {
      // store.commit('setError', (error.response.data) || store.state.defaultError);
      // go back
      // window.location.href = `${process.env.REACT_APP_BASE_HREF}/app/dashboard`;

      console.log('403 ERROR');

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export { securedAxiosInstance, plainAxiosInstance };
